import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function formatMetricLabel(key) {
  if (!key) return '';
  // Insert space before capital letters and numbers
  const result = key.replace(/([A-Z]|[0-9]+)/g, " $1");
  return result.charAt(0).toUpperCase() + result.slice(1).trim();
}
